define('home/views/UserCollectionView',[
    'home/mixins/withItemRemovalSkipped',

    'home/views/UserCardView',
    'home/views/common/FetchableCollectionView',

    'home/mixins/withViewFeedTracking',
], function (
    withItemRemovalSkipped,

    UserCardView,
    FetchableCollectionView,

    withViewFeedTracking
) {
    'use strict';

    var UserCollectionView = FetchableCollectionView.extend({
        itemView: UserCardView,
        className: 'cards',

        emptyViewOptions: function () {
            return {
                model: this.options.user,
            };
        },

    });

    withItemRemovalSkipped.call(UserCollectionView.prototype);
    withViewFeedTracking.call(UserCollectionView.prototype);

    return UserCollectionView;
});

